<template>
  <div>
    <div @click="chiudi()" v-if="1" class="form d-flex align-items-center justify-content-center">
      <transition
        v-on:after-enter="daiFocus()"
        name="custom"
        v-on:after-leave="esci()"
        enter-active-class="swal2-show"
        leave-active-class="swal2-hide"
      >
        <div
          @click.stop
          v-if="mostraInserimento"
          class="evidenzia container"
          style="background-color:white;"
        >
          <div class="row intestazione">
            <div class="col-12 text-right my-auto">
              <i class="fas fa-times-circle"></i>
            </div>
          </div>
          <div class="container">
            <div class="row w-100 d-flex flex-column align-items-center justify-content-center">
              <div
                :class="{ 'unsetted' : (!img && ricambio.tipo==='0') }"
                class="img_selector d-flex align-items-center justify-content-center position-relative"
              >
                <i v-if="!img && ricambio.tipo==='0'" class="fas fa-camera-retro"></i>
                <imageLoader
                  v-if="img || ricambio.tipo!=='0'"
                  class="fa-1x"
                  :imgInfo="ricambio"
                  style="height:85%; width:auto;"
                ></imageLoader>
              </div>
              <input placeholder="Nome Ricambio" />
            </div>
          </div>
          <div class="row add">
            <div class="col-8 d-flex p-0 m-0 align-items-center justify-content-center">
              <div class="select">
                <select v-model="ricambio.tipo" class="select__field">
                  <option value="0">Seleziona tipo ricambio</option>
                  <option value="display">Display</option>
                  <option value="battery">Batteria</option>
                  <option value="dock">Dock Ricarica</option>
                  <option value="loud">Loud Speaker</option>
                  <option value="ear">Ear Speaker</option>
                  <option value="other">Altro</option>
                </select>
              </div>
            </div>

            <div class="col-4 p-0 m-0 d-flex justify-content-center align-items-center">
              <div
                @click="saveDeviceDettails()"
                class="tasto d-flex justify-content-center align-items-center"
              >Salva</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../main.js";
import { db } from "@/components/Firebase_Conn";
import { ref } from "@/components/puntatori";
import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "creaRicambio",
  directives: {},
  data() {
    return {
      mostraInserimento: false,
      ricambio: { tipo: "0" },
      img: undefined //DA QUI CAPIRO' SE HO CARICATO L'IMMAGINE O MENO
      //VARIABILI AMBIENTE
    };
  },
  props: [],
  computed: {},
  methods: {
    daiFocus() {},
    chiudi() {
      this.mostraInserimento = false;
    },
    esci() {}
  },
  mounted() {
    let self = this;
    Vue.nextTick(function() {
      self.mostraInserimento = true;
    });
  },
  watch: {}
};
</script>

<style scoped>
.img_selector {
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
  height: 10vw;
  width: 10vw;
  border: solid 4px #ececec;
  color: #b4b6b6;
  font-size: 2.7vw;
}
.unsetted {
  background-color: #ececec;
}

.blocco {
  padding-top: 4vh;
  padding-bottom: 4vh;
}
.consegna {
  padding-top: 2vh;
  padding-left: 2vw;
  width: 100%;
  height: 6vh;
  margin-bottom: 2vh;
}

.mostra {
  margin-left: 1vw;
  font-weight: 10;
  font-size: 1.5vh;
  color: darkgray;
}

.info {
  margin-left: 10px;
  padding: 0.5vh;
  font-size: 10px;
  font-weight: 10;
  color: #7f8c8d;
}

.tasto {
  width: 80%;
  height: 5vh;
  background-color: #27ae60;
  color: white;
  cursor: pointer;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
  position: relative;
}

.add {
  margin-top: 2vw;

  height: 8vh;
  background-color: white;
  font-weight: bold;
  font-size: 1.7vh;
  -webkit-border-bottom-right-radius: 9px;
  -webkit-border-bottom-left-radius: 9px;
  -moz-border-radius-bottomright: 9px;
  -moz-border-radius-bottomleft: 9px;
  border-bottom-right-radius: 9px;
  border-bottom-left-radius: 9px;
}

.form {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 9999;
  height: 100%;
  width: 100%;
}

.scadenza {
}
.scadenza:focus {
  outline: none;
}

.form > div {
  width: 34vw;
  background-color: white;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.form input:not([type="checkbox"]) {
  margin-top: 3vh;
  margin-bottom: 5vh;
  height: 5vh;
  width: 50%;
  border: none;
  border-bottom: solid 2px white;
  transition: all 0.2s;
  margin-bottom: 1vh;
  text-align: center;
  color: #888888;
  font-size: 1.7vw;
}
.form input:not([type="checkbox"]):focus {
  outline: none;
  border-bottom: solid 2px #007bff;
}

.form label {
  font-size: 1.7vh;
  color: #848484;
  margin-top: 1vh;
  margin-left: 1vh;
  margin-bottom: 0vh;
}

.intestazione {
  height: 6vh;

  color: grey;
  font-weight: bold;
  font-size: 2vh;

  -webkit-border-radius: 9px;
  -webkit-border-bottom-right-radius: 3px;
  -webkit-border-bottom-left-radius: 3px;
  -moz-border-radius: 9px;
  -moz-border-radius-bottomright: 3px;
  -moz-border-radius-bottomleft: 3px;
  border-radius: 9px;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.select {
  overflow: hidden;
  position: relative;
  border-radius: 3px;
  width: 90%;
}

.select:after {
  content: "▼";
  display: flex;
  align-items: center;

  position: absolute;
  right: 1.5vw;
  top: 0;
  z-index: 1;
  text-align: center;
  height: 100%;
  pointer-events: none;
  font-size: 1.6vh;
  color: #5e5e5e;
}

.select__field {
  margin-right: 1vw;
  border: 0;
  background-color: #e6e6e6;
  padding-left: 1.5vw;
  padding-right: 2.2vw;
  -webkit-appearance: none; /* remove the strong OSX influence from Webkit */
  height: 5vh;
  width: 100%;
  color: #616263;

  outline: none;
  border: none;

  -webkit-appearance: none;
  /* for webkit browsers */
  -moz-appearance: none;
  /* for firefox */
  appearance: none;
  /* for modern browsers */
}

/* remove default caret for ie */

.select__field::-ms-expand {
  display: none;
}
</style>
